/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */

import { Component } from '@angular/core';

@Component({
  selector: 'martmax-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {
  public ngOnInit() {
  
  }
}




// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home.component.ts